/** CLP (Mambu CCA): metadata con pipes, ej. `0507|355646117298|260612|110943` */
export const VIRTUAL_ACCOUNT_INTERNAL_COMMENT_CLP_PATTERN = /^\d+\|.+\|/;

/** COP (Mambu ACH): metadata numérica contigua sin pipes, ej. `999900009220260617000015070000001` */
export const VIRTUAL_ACCOUNT_INTERNAL_COMMENT_COP_MIN_LENGTH = 30;
export const VIRTUAL_ACCOUNT_INTERNAL_COMMENT_COP_PATTERN = /^\d+$/;

